/**
 * Вьюновые — 3 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ВЬЮНОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'weatherfish',
        семейство: 'вьюновые',
        latin: 'Misgurnus fossilis',
        повадка: 'мелочь',
        minKg: 0.02,
        maxKg: 0.3,
        typicalKg: 0.07,
        typicalLengthM: 0.2,
        depthM: 1,
        depthBandM: 1,
        сложение: 'змеевидное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 5, опт: 20, макс: 30 },
        течение: 'стоячая',
        держится: ['ил', 'трава', 'коряги'],
        стая: 'одиночка',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
        ],
    },
    {
        id: 'spined_loach',
        семейство: 'вьюновые',
        latin: 'Cobitis taenia',
        повадка: 'мелочь',
        minKg: 0.003,
        maxKg: 0.03,
        typicalKg: 0.008,
        typicalLengthM: 0.08,
        depthM: 1,
        depthBandM: 1,
        сложение: 'змеевидное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 6, опт: 18, макс: 28 },
        течение: 'слабое',
        держится: ['твёрдое_дно', 'ил', 'трава'],
        стая: 'одиночка',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'червь', вес: 0.2 },
        ],
    },
    {
        id: 'stone_loach',
        семейство: 'вьюновые',
        latin: 'Barbatula barbatula',
        повадка: 'мелочь',
        minKg: 0.005,
        maxKg: 0.04,
        typicalKg: 0.012,
        typicalLengthM: 0.1,
        depthM: 0.8,
        depthBandM: 0.8,
        сложение: 'змеевидное',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'ночная',
        вода: { мин: 2, опт: 14, макс: 22 },
        течение: 'сильное',
        держится: ['камни', 'перекат', 'твёрдое_дно'],
        стая: 'одиночка',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'рачок', вес: 0.2 },
        ],
    },
];
//# sourceMappingURL=cobitids.js.map